export interface EnergyColumn {
  id: string;
  header: string;
  key: keyof typeof defaultColumnVisibility;
}

export const availableColumns: EnergyColumn[] = [
  { id: 'tree', header: 'Name', key: 'tree' },
  { id: 'sessions', header: 'Sessions', key: 'sessions' },
  { id: 'chargingStatus', header: 'Charging Status', key: 'chargingStatus' },
  { id: 'lastCommunication', header: 'Status Update', key: 'lastCommunication' },
  { id: 'offered', header: 'Offered [A]', key: 'offered' },
  { id: 'actual', header: 'Actual [A]', key: 'actual' },
  { id: 'allocated', header: 'Allocated / Limit', key: 'allocated' },
];

export const defaultColumnVisibility = {
  tree: true,
  sessions: true,
  chargingStatus: true,
  lastCommunication: true,
  offered: true,
  actual: true,
  allocated: true,
};

export type EnergyColumnVisibility = typeof defaultColumnVisibility;